
<!-- Done -->
<div class ="container-alert success" *ngIf="type==='success'">
  <div class="subcontainer">
    <img src="../../../../../assets/done-vector.svg" alt="icon done"/>
    <p>Done</p>
  </div>
  <div class="conatiner-message">
    {{Message}}
  </div>
</div>

<!-- Error -->
<div class ="container-alert error" *ngIf="type==='error'">
  <div class="subcontainer">
    <img src="../../../../../assets/icon-error.svg" alt="icon error"/>
    <p>Error</p>
  </div>
  <div class="conatiner-message">
    {{Message}}
  </div>
</div>

<!-- Alert-->
<div class ="container-alert warning" *ngIf="type==='warning'">
  <div class="subcontainer">
    <img src="../../../../../assets/icon-alert.svg" alt="icon alert"/>
    <p>Alert</p>
  </div>
  <div class="conatiner-message">
    {{Message}}
  </div>
</div>